import type { HeadersFunction, LoaderArgs, MetaFunction } from "@remix-run/node";
import { json } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import clsx from "clsx";
import common from "../../../data/common.json";
import { ArticleLayout } from "@/components/ArticleLayout";
import { PageContainer } from "@/components/PageContainer";
import { SNSShareSection } from "@/components/SNSShareSection";
import { TopicsArticle } from "@/components/Topics/Article";
import { fetchTopics } from "@/lib/microcms.server";
import { CacheRevalidateMinutes, notFound } from "@/lib/responses.server";
import { createOGP } from "@/utilities/ogp";

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  return createOGP({ pageName: data?.post.title, path: `/topics/article/${data?.post.id}` });
};

export const headers: HeadersFunction = () => {
  return {
    "Cache-Control": CacheRevalidateMinutes(),
  };
};

export async function loader({ params }: LoaderArgs) {
  const id = params.id;
  const post = await fetchTopics(id!).catch(() => null);
  if (!post) {
    throw notFound();
  }

  return json({ post });
}

export default function TopicsArticlePage() {
  const { post } = useLoaderData<typeof loader>();
  const shareURL = `${common.meta.title}/events/article/${post?.id}`;
  const shareText = `${post?.title} / ${common.meta.url}`;

  return (
    <PageContainer>
      <ArticleLayout
        paths={[
          { name: "ホーム", url: "/" },
          { name: "トピックス", url: "/topics" },
          { name: post.title, url: `/topics/article/${post.id}` },
        ]}
      >
        <div className={clsx("flex", "flex-col", "space-y-8")}>
          <TopicsArticle post={post} shareURL={shareURL} shareText={shareText} />
          <hr />
          <SNSShareSection url={shareURL} text={shareText} />
        </div>
      </ArticleLayout>
    </PageContainer>
  );
}
